import { I18nComponente } from "@/types/gerais"

export const OListaDeProfissionaisi18n: I18nComponente = {
  "pt-BR": {
    profissionalAlocado: "profissional alocado",
    profissionaisAlocados: "profissionais alocados",
    nenhum: "nenhum"
  },
  "es-CO": {
    profissionalAlocado: "profesional asignado",
    profissionaisAlocados: "profesionales asignados",
    nenhum: "ninguno"
  }
}
